export const DELETE_CONFIRMATION_PHRASE = "delete";

export const matchesConfirmationPhrase = (input) =>
  String(input ?? "")
    .trim()
    .toLowerCase() === DELETE_CONFIRMATION_PHRASE;
